import svc from "../../services/api/ProductTransferService";

export const GET_PRODUCT_TRANSFER_SUCCESS = "GET_PRODUCT_TRANSFER_SUCCESS";
export const GET_PRODUCT_TRANSFER_FAIL = "GET_PRODUCT_TRANSFER_FAIL";

export function transferToProduct(productName, additionalRouteInfo = null) {
    return (dispatch) => {
        return svc.getProductTransfer(productName, additionalRouteInfo)
            .then((result) => {
                dispatch(getProductTransferSuccess(result));
            })
            .catch((err) => dispatch(getProductTransferFail(err)));
    };
}

export function getProductTransferSuccess(result) {
    return { type: GET_PRODUCT_TRANSFER_SUCCESS, redirectUrl: result.redirectUrl};
}

export function getProductTransferFail() {
    return { type: GET_PRODUCT_TRANSFER_FAIL};
}
